import { Search, Bell, ChevronDown, Building2, ShieldCheck, Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { LinkLogo } from '@/components/ui/LinkLogo';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export function TopBar() {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <header className="h-16 bg-card/50 backdrop-blur-xl border-b border-border flex items-center justify-between px-6">
      {/* Left: Brand Logo + Facility Selector */}
      <div className="flex items-center gap-6">
        {/* Brand Logo - Clickable to Home */}
        <button 
          onClick={handleLogoClick}
          className="flex items-center gap-2 group cursor-pointer transition-all duration-200 hover:opacity-80 md:hidden"
        >
          <LinkLogo showText={false} size="sm" />
        </button>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" className="h-9 gap-2 bg-secondary/50 border-border hover:bg-secondary">
              <Building2 className="w-4 h-4 text-muted-foreground" />
              <span className="font-medium">Dr. Larken Practice</span>
              <ChevronDown className="w-4 h-4 text-muted-foreground" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" className="w-56">
            <DropdownMenuItem className="gap-2">
              <Building2 className="w-4 h-4" />
              Dr. Larken Practice
            </DropdownMenuItem>
            <DropdownMenuItem className="gap-2 text-muted-foreground">
              <Building2 className="w-4 h-4" />
              Summit Spine Center
            </DropdownMenuItem>
            <DropdownMenuItem className="gap-2 text-muted-foreground">
              <Building2 className="w-4 h-4" />
              Valley Sports Medicine
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>

        <div className="text-xs text-muted-foreground">
          Last 30 days
        </div>
      </div>

      {/* Center: Search */}
      <div className="flex-1 max-w-md mx-8">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <input
            type="text"
            placeholder="Search claims, patients, payers..."
            className="w-full h-9 pl-10 pr-4 bg-secondary/50 border border-border rounded-lg text-sm placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary/50"
          />
          <kbd className="absolute right-3 top-1/2 -translate-y-1/2 px-1.5 py-0.5 text-[10px] font-mono text-muted-foreground bg-muted rounded">
            ⌘K
          </kbd>
        </div>
      </div>

      {/* Right: System Health + Actions */}
      <div className="flex items-center gap-3">
        {/* System Health Indicators */}
        <div className="hidden lg:flex items-center gap-3 mr-2">
          <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-success/10 border border-success/20">
            <ShieldCheck className="w-3.5 h-3.5 text-success" />
            <span className="text-[11px] font-medium text-success">SOC 2 Type II: Active</span>
          </div>
          <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-success/10 border border-success/20">
            <Lock className="w-3.5 h-3.5 text-success" />
            <span className="text-[11px] font-medium text-success">AES-256: Verified</span>
          </div>
        </div>

        <Button variant="ghost" size="icon" className="relative">
          <Bell className="w-5 h-5 text-muted-foreground" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-primary rounded-full" />
        </Button>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="h-9 gap-2 px-2">
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-primary/80 to-primary/40 flex items-center justify-center">
                <span className="text-xs font-semibold text-primary-foreground">SJ</span>
              </div>
              <ChevronDown className="w-4 h-4 text-muted-foreground" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48">
            <DropdownMenuItem>Profile</DropdownMenuItem>
            <DropdownMenuItem>Account Settings</DropdownMenuItem>
            <DropdownMenuItem className="text-destructive">Sign Out</DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}